module.exports = __webpack_public_path__ + "components/greenroom-articles/static/placeholder-6aa087fa5786d508a3c02b54e0b40e66.png";